var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-sheet',{staticStyle:{"background-color":"inherit"},attrs:{"height":_vm.height}})
}
var staticRenderFns = []

export { render, staticRenderFns }